import { colors, getSpacing } from '@cabonline/ui-shared';
import styled from '@emotion/styled';

export const StyledErrorDetails = styled.pre`
  width: 100%;
  overflow-x: auto;
  font-size: 0.8rem;
  text-align: left;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
  padding: ${getSpacing('xs')};
  background: ${colors.gray5};
  border-radius: 4px;
`;
